import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { NavigationHeader } from 'components/NavigationHeader';
import { PageScrollView } from 'components/Page';
import { useEsc } from 'hooks/useEsc';
import { useSelector } from 'hooks/useSelector';
import { orderBy as naturalOrderBy } from 'natural-orderby';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL_BACK } from 'store/actions';
import { CREATE_ASSESSMENT } from 'store/assessments/actions';
import { selectAssetOrganisationId } from 'store/assets/selectors';
import { selectOrganisation } from 'store/organisations/selectors';

export const CreateAssessmentScreen: React.FC<
  ModalScreenProps<ModalScreens.CREATEASSESSMENT>
> = ({ route }) => {
  const { assetId, complianceSubtypeId } = route.params;

  const dispatch = useDispatch();

  const organisationId = useSelector((state) =>
    selectAssetOrganisationId(state, assetId),
  );
  const organisation = useSelector((state) =>
    selectOrganisation(state, organisationId),
  );

  const templates = complianceSubtypeId
    ? Object.values(organisation.assessmentTemplates).filter(
        (template) =>
          !template.deleted &&
          template.compliance_subtype_id === complianceSubtypeId,
      )
    : [];

  const handleCreateAssessment = (templateId: string) => {
    dispatch(NAVIGATE_MODAL_BACK());
    setTimeout(
      () =>
        dispatch(
          CREATE_ASSESSMENT({
            assetId,
            templateId,
          }),
        ),
      1,
    );
  };

  useEsc(() => dispatch(NAVIGATE_MODAL_BACK()));

  return (
    <PageScrollView
      header={
        <NavigationHeader
          heading="Create Assessment"
          onPressCancelButton={() => dispatch(NAVIGATE_MODAL_BACK())}
        />
      }
    >
      <Card>
        {naturalOrderBy(templates, 'name').map((template) => (
          <CardRow
            key={template.id}
            label={template.name}
            value={
              template.description
                ?.replace(/(?:\r\n|\r|\n)/g, ' ')
                .replace(/ +/g, ' ') || ''
            }
            labelAlignTop
            navigationType="add"
            onPress={() => handleCreateAssessment(template.id)}
          />
        ))}
      </Card>
    </PageScrollView>
  );
};
